import React, { StyleHTMLAttributes } from 'react'

interface RequiredAsteriskProps {
  style?: React.CSSProperties
}

const RequiredAsterisk = (props: RequiredAsteriskProps) => {
  return <span style={{ color: 'red', ...props.style }}>*</span>
}

export default RequiredAsterisk
